<ng-container>
  <div
    class="amount-exchnage-wrapper"
    [ngClass]="{ fxRateErrorTopMargin: fxRateError }"
  >
    <div class="amount-wrapper">
      <div class="form-amount-comtainer">
        <span
          [ngClass]="{ 'disable-input': _disableAmount }"
          class="text-label"
        >
          {{ labels?.stellar?.estimate?.amount }}
        </span>
        <input
          [ngClass]="{ 'disable-input': _disableAmount }"
          class="amount"
          type="number"
          min="0"
          placeholder="0"
          [formControl]="amountControl"
          [readonly]="_disableAmount"
          (focusout)="_disableAmount ? null : formatAmount.emit(true)"
        />
      </div>
      <div class="currency-container">
        <span class="currency"> USDC </span>
        <img src="assets\images\glob-currency.svg" alt="" class="usdc-icon" />
      </div>
    </div>

    <div class="exchange-wrapper" *ngIf="!fxRateError">
      <div class="exchange-currency">
        <p class="text-label">
          {{ labels?.stellar?.estimate?.exchangeCurrency }}
          <!-- <sup class="sup">1</sup> -->
          <sup class="sup"> 1 </sup>
        </p>
        <span class="exchange-amount-label">
          {{ exchangeAmount }}
        </span>
      </div>
      <ng-container
        *ngIf="receiveCurrencies.length > 1; else displaySingleCurrency"
      >
        <div
          class="exchangeDropdown"
          [ngClass]="{ active: isDropdownOpen }"
          #exchangeDropdown
        >
          <div class="exchange-label-container">
            <span class="exchange-text-label">
              <!-- {{ fxRateObj?.currency || receiveCurrency}} -->
              {{ getRecieveCurrencyCode(receiveCurrency!) }}
            </span>
          </div>
          <div class="dropdown-container">
            <button class="dropdown-button" (click)="exchangeCurrencyToggle()">
              <img
                src="assets/images/arr.chevron.down.small.svg"
                alt="chevron-down"
                [ngStyle]="{
                  transform:
                    isDropdownOpen && receiveCurrencies.length > 1
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                }"
              />
            </button>
          </div>
          <div
            class="exchange-web-view-dropdown"
            [@dropdown]
            *ngIf="
              isDropdownOpen &&
              (isMobile$ | async) === false &&
              receiveCurrencies.length > 1
            "
          >
            <ul class="exchange-list">
              <li
                [ngStyle]="{
                  background:
                    receiveCurrency! === rc ? 'var(--gray-50, #f2f2f2)' : null
                }"
                class="list-item"
                *ngFor="let rc of receiveCurrencies"
                (click)="changeCurrency(rc)"
              >
                <span class="exchange-label">
                  {{ rc }}
                </span>
                <span class="selected-currency">
                  <img
                    src="assets\images\checked-circle.svg"
                    alt="checked-circle"
                    *ngIf="receiveCurrency! === rc"
                  />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-template #displaySingleCurrency>
        <div class="single-currency-container">
          <div class="single-currency">
            <span
              class="currency-label"
              *ngFor="let currency of receiveCurrencies"
            >
              {{ currency }}
            </span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div
    class="exchangeMobileViewDrawer"
    [@slideInOutAnimation]="isDropdownOpen ? 'in' : 'out'"
    (click)="$event.stopPropagation()"
    *ngIf="
      (isMobile$ | async) && isDropdownOpen && receiveCurrencies.length > 1
    "
  >
    <div class="top-bar">
      <div class="page-title"></div>
      <div class="icon-right" (click)="exchangeCurrencyToggle()">
        <img src="assets\images\close-icon.svg" alt="close-icon" />
      </div>
    </div>
    <div class="currency-frame">
      <div class="header">
        <span class="text">
          {{ sdfCardLabels.landingPage.selectCurrency }}
        </span>
      </div>
      <div class="sub-header">
        <span class="text">
          {{ countryName }} {{ sdfCardLabels.landingPage.multiCurrency }}.
        </span>
      </div>
    </div>

    <ng-container *ngIf="receiveCurrencies">
      <div class="currency-cards-container">
        <div
          *ngFor="let rc of receiveCurrencies"
          class="currency-cards"
          [ngStyle]="{
            border:
              receiveCurrency === rc
                ? '1px solid var(--affordance-selected, #333)'
                : null
          }"
          (click)="changeCurrency(rc)"
        >
          <div class="currenc-details-container">
            <div class="currency-details">
              <div class="currency-header-label">
                <span class="header-text">
                  {{ rc }}
                </span>
              </div>
              <!-- <div class="currency-sub-header-label">
                <span class="sub-text"> Lorem ipsum. </span>
              </div> -->
            </div>
            <div class="icon-selected-checkmark">
              <img
                src="assets\images\checked-circle.svg"
                alt="checked-circle"
                *ngIf="receiveCurrency === rc"
              />
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container
    *ngIf="
      (isMobile$ | async) && isDropdownOpen && receiveCurrencies.length > 1
    "
  >
    <div
      [@overlayFadeInOutAnimation]
      (click)="$event.stopPropagation()"
      class="overlay"
      [ngClass]="{ active: isDropdownOpen && (isMobile$ | async) }"
    ></div>
  </ng-container>
</ng-container>
